<template>
  <div :class="[($route.name === 'loanSummary' || $route.name === 'paymentIntroduction') ? 'absolute-style' : '']" class="main-header">
    <div class="user-infomation hidden sm:hidden md:hidden lg:flex">
      <div class="user-notify">
        <i class="vlicon icon-bell-alt" @click="notificationShow = !notificationShow"></i>
        <i class="notify-number" v-if="!allRead"></i>
        <div class="usernotify-content"  v-if="notificationShow">
          <div class="usernotify-popup-header">
            <div>Thông báo</div>
            <div class="usernotify-popup-action">
             <span @click="handleClickAllRead">Đánh dấu đã đọc tất cả</span>
              <span> • </span>
              <span @click="handleClickDeleteAll">Xoá tất cả</span>
            </div>
          </div>
          <perfect-scrollbar>
          <ul class="usernotify-popup" id="usernotifyPopup">
            <li v-for="(item, index) in notifications" :key="index">
              <div
                @click.stop="showDetailNotification(item.NotificationId, item.Title, item.Content)"
                :class="{ 'active': item.IsRead != 1  && allRead === false}"
                class="notification-item"
              >
                <img
                  height="33px"
                  class="notification-icon"
                  src="@/assets/img/noti-icon.svg"
                  alt="Icon"
                />
                <p
                  class="notification-title"
                >
                  {{item.Title}}
                </p>
                <p
                  class="notification-des truncate text-left"
                >
                  {{item.Content}}
                </p>
                <p
                  class="notification-time"
                >
                  {{ item.Time | moment("from", "now") }}
                </p>
                <a @click.stop="handleDeleteOne(item.NotificationId)" href="#"
                  class="notification-dismiss"
                >
                  <img
                    src="@/assets/img/icon-close.svg"
                    alt="Delete"
                  />
                </a>
              </div>
            </li>
          </ul>
            <infinite-loading spinner="bubbles" @infinite="fetchData">
              <div class="text-red" slot="no-more"></div>
              <div slot="no-results"></div>
              <!--<div class="text-red" slot="no-results">No more notifications</div>-->
            </infinite-loading>
          </perfect-scrollbar>
        </div>
      </div>
      <div class="user-dropdown">
        <div class="dropdown inline-block relative">
          <!--<div class="user-name">
            {{$store.state.user.currentUser.FullName}}
            <i class="vlicon icon-down-dir"></i>
          </div>-->
          <!--<ul class="dropdown-menu absolute pt-1">
            <li class="">
              <a
                class="rounded-t bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"
                href="#"
              >One</a
              >
            </li>
            <li class="">
              <a
                class="bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"
                href="#"
              >Two</a
              >
            </li>
            <li class="">
              <a
                class="rounded-b bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"
                href="#"
              >Three is the magic
                number</a
              >
            </li>
          </ul>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { AuthService } from '../services/auth.service'
import { NotificationsService } from '../services/notifications.service'
import infiniteHandler from '@/mixins/infiniteScroll'
import InfiniteLoading from 'vue-infinite-loading'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  name: 'MainHeader',
  mixins: [infiniteHandler],
  components: {
    InfiniteLoading,
    PerfectScrollbar
  },
  data () {
    return {
      notificationShow: false,
      isShownModal: false,
      titleDetail: '',
      contentDetail: ''
    }
  },
  computed: {
    ...mapState('notifications', {
      notifications: 'items'
    }),
    ...mapGetters('notifications', [
      'allRead'
    ])
  },
  methods: {
    logout () {
      AuthService.makeLogout()
    },
    fetchData: function ($state) {
      this.infiniteHandler($state, 'notifications', 'Notification/GetNotification', { pageSize: 5 })
    },
    handleClickAllRead () {
      NotificationsService.setAllRead()
    },
    handleClickDeleteAll () {
      NotificationsService.deleteAll()
    },
    handleDeleteOne (notificationId) {
      NotificationsService.deleteOne(notificationId)
    },
    showDetailNotification (notificationId, title, content) {
      NotificationsService.setRead(notificationId)
      this.$bus.$emit('openModal', {
        title: title,
        content: content
      })
    }
  },
  created () {
    this.$store.dispatch('notifications/getListPublic', { params: { pageIndex: 1, pageSize: 5 } })
  }
}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
